import React from 'react'
import TableRowsIcon from '@mui/icons-material/TableRows';
import { Handle, Position } from '@xyflow/react';
import { Box, Typography, useTheme } from '@mui/material';
import { CustomTooltip } from '../../../../components/TooltipCustomStyle';
import TooltipStatusTitle from '../../../../components/TooltipStatusTitle';
import ErrorIcon from '@mui/icons-material/Error';
import CheckHandleNodeEvent from '../../../../utils/CheckHandleNodeEvent';

function DataNode({ selected, data }) {
    const theme = useTheme();
    return (
        <div
            className={`min-w-[60px] h-12 bg-white ${selected ? 'border border-blue-600' : 'border border-gray-300'}
            rounded-tl-sm rounded-bl-sm rounded-tr-2xl rounded-br-2xl px-2 py-2 
            cursor-pointer flex justify-center items-center relative overflow-visible`}
        >
            <TableRowsIcon color="primary" sx={{ fontSize: '26px', justifyContent: 'center', alignItems: 'center' }} />
            <div
                className="absolute bottom-[-25px] left-1/2 -translate-x-1/2 w-max whitespace-nowrap"
            >
                <Typography variant='subtitle2' color='gray'>{data?.general_properties?.drg?.name}</Typography>
            </div>
            {data?.error_text.length > 0 &&
                <div
                    style={{
                        position: 'absolute',
                        top: '-15px',
                        right: '5%',
                        transform: 'translate(-50%, 0)',
                        zIndex: 1000,
                        textAlign: 'center',
                    }}
                >
                    <CustomTooltip title={<TooltipStatusTitle headerTitle="Error" listDetails={data?.error_text} />} arrow placement="top" tooltipcolorstyle={theme.palette.error.main}>
                        <Box
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                borderRadius: '50%',
                                background: '#fff',
                                width: 15,
                                height: 15,
                                marginTop: '5px'
                            }}
                        >
                            <ErrorIcon sx={{
                                color: theme.palette.error.main,
                                fontSize: 18,
                            }} />
                        </Box>
                    </CustomTooltip>
                </div>
            }
            {/* <Handle position={Position.Left} type="target" /> */}
            <Handle
                id="left-target"
                type="target"
                position={Position.Left}
                style={CheckHandleNodeEvent(data, selected)}
            />
        </div>
    )
}

export default DataNode